var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "HorizontalSelector"
  }, [_vm._l(_vm.getCurrentItems, function (item, index) {
    return [_vm.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue"
      }],
      key: 'horizontal_selector_input_' + index,
      staticClass: "HorizontalSelector-input",
      attrs: {
        "id": item.id,
        "name": "HorizontalSelector",
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, item.id) > -1 : _vm.currentValue
      },
      on: {
        "change": [function ($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.currentValue = $$c;
          }
        }, _vm.updateValue]
      }
    }) : _vm.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue"
      }],
      key: 'horizontal_selector_input_' + index,
      staticClass: "HorizontalSelector-input",
      attrs: {
        "id": item.id,
        "name": "HorizontalSelector",
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.currentValue, item.id)
      },
      on: {
        "change": [function ($event) {
          _vm.currentValue = item.id;
        }, _vm.updateValue]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue"
      }],
      key: 'horizontal_selector_input_' + index,
      staticClass: "HorizontalSelector-input",
      attrs: {
        "id": item.id,
        "name": "HorizontalSelector",
        "type": _vm.type
      },
      domProps: {
        "value": item.id,
        "value": _vm.currentValue
      },
      on: {
        "change": _vm.updateValue,
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.currentValue = $event.target.value;
        }
      }
    }), _c('label', {
      key: 'horizontal_selector_label_' + index,
      staticClass: "HorizontalSelector-label",
      attrs: {
        "for": item.id
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }